export enum EIdentity {
  OPU_USER = 'OPU_USER',
  STUDENT = 'STUDENT',
  ESTABLISHMENT_USER = 'ESTABLISHMENT_USER',
  ESTABLISHMENT_USER_ADMIN = 'admin',
}
